import React from "react";
import Footer from "../footer";
import Navbar from "../navbar";

function ProductSkeleton() {
  return (
    <div className="product-skeleton">
      <Navbar />
      
      {/* Main Content Banner Skeleton */}
      <div className="w-full h-8 flex items-center justify-center">
        <div className="bg-gray-200 animate-pulse w-64 h-4 rounded"></div>
      </div>
      
      <div className="container mx-auto px-4 mt-6">
        <div className="flex flex-col md:flex-row gap-8">
          {/* Product Images Skeleton */}
          <div className="w-full md:w-1/2 flex flex-col gap-4">
            <div className="bg-gray-200 animate-pulse w-full aspect-square rounded"></div>
            <div className="bg-gray-200 animate-pulse w-full aspect-square rounded"></div>
          </div>
          
          {/* Product Details Skeleton */}
          <div className="w-full md:w-1/2 flex flex-col gap-4">
            {/* Title */}
            <div className="bg-gray-200 animate-pulse w-3/4 h-6 rounded"></div>
            
            {/* Price */}
            <div className="mt-2">
              <div className="bg-gray-200 animate-pulse w-24 h-3 rounded mb-1"></div>
              <div className="bg-gray-200 animate-pulse w-16 h-5 rounded"></div>
            </div>
            
            {/* Colors */}
            <div className="mt-4">
              <div className="flex gap-2 mt-2">
                {[1, 2, 3, 4].map((item) => (
                  <div key={item} className="bg-gray-200 animate-pulse w-8 h-8 rounded-full"></div>
                ))}
              </div>
            </div>
            
            {/* Sizes */}
            <div className="mt-4">
              <div className="bg-gray-200 animate-pulse w-16 h-4 rounded mb-2"></div>
              <div className="flex gap-2">
                {["XS", "S", "M", "L", "XL", "XXL"].map((size) => (
                  <div key={size} className="bg-gray-200 animate-pulse w-10 h-10 rounded"></div>
                ))}
              </div>
            </div>
            
            {/* Add to Cart Button */}
            <div className="mt-6">
              <div className="bg-gray-300 animate-pulse w-full h-12 rounded"></div>
            </div>
            
            {/* Info Paragraphs */}
            <div className="mt-4 flex flex-col gap-2">
              <div className="bg-gray-200 animate-pulse w-full h-4 rounded"></div>
              <div className="bg-gray-200 animate-pulse w-full h-4 rounded"></div>
            </div>
            
            {/* Care Guide */}
            <div className="mt-6 border border-gray-200 p-4 rounded">
              <div className="bg-gray-200 animate-pulse w-1/2 h-5 rounded mb-3"></div>
              <div className="bg-gray-200 animate-pulse w-full h-3 rounded mb-2"></div>
              <div className="bg-gray-200 animate-pulse w-full h-3 rounded mb-2"></div>
              <div className="bg-gray-200 animate-pulse w-1/3 h-3 rounded mb-2"></div>
            </div>
          </div>
        </div>
        
        {/* Similar Products Skeleton */}
        <div className="mt-12">
          <div className="bg-gray-200 animate-pulse w-48 h-6 rounded mb-6"></div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[1, 2, 3, 4].map((item) => (
              <div key={item} className="flex flex-col gap-2">
                <div className="bg-gray-200 animate-pulse w-full aspect-square rounded"></div>
                <div className="bg-gray-200 animate-pulse w-3/4 h-4 rounded"></div>
                <div className="bg-gray-200 animate-pulse w-1/3 h-4 rounded"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
}

export default ProductSkeleton;